import { render, staticRenderFns } from "./PosCheckoutModal.vue?vue&type=template&id=545dbacb"
import script from "./PosCheckoutModal.vue?vue&type=script&lang=js"
export * from "./PosCheckoutModal.vue?vue&type=script&lang=js"
import style0 from "./PosCheckoutModal.vue?vue&type=style&index=0&id=545dbacb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports